import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const optionsFormData = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'multipart/form-data',
    }
};

const actions = {
    getInterventions(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/interventions', payload, options)
            .then((response) => {
                return response
            })
    },

    getInterventionCategories() {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/intervention_categories')
            .then((response) => {
                return response
            })
    },

    getInterventionStatuses() {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/intervention_statuses')
            .then((response) => {
                return response
            })
    },

    getInterventionDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/interventions/'+ payload.id)
            .then((response) => {
                return response
            })
    },

    getInterventionContacts(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload+ '/contacts')
            .then((response) => {
                return response
            })
    },

    getInterventionDevicesDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/interventions/'+ payload.id +'/devices')
            .then((response) => {
                return response
            })
    },

    getSignatureData(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/interventions/'+ payload +'/get_signature_data')
            .then((response) => {
                return response
            })
    },

    getDocuments(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL+'/interventions/' + payload.id + '/get_documents')
            .then((response) => {
                return response
            })
    },

    addIntervention(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/interventions/store', payload, options)
            .then((response) => {
                return response
            })
    },

    updateInterventionComment(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.id + '/comment', {
            comment: payload.comment
        }, options).then((response) => {
            return response
        })
    },

    deleteIntervention(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.id + '/delete', {
            reason: payload.reason
        }, options).then((response) => {
            return response
        })
    },

    addInterventionAsImpossible(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/interventions/store_as_impossible', payload, options)
            .then((response) => {
                return response
            })
    },

    addInterventionDevicesReports(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/interventions/'+payload.interventionId+'/devices/reports', payload, options)
            .then((response) => {
                return response
            })
    },

    storeDocument(context, payload) {
        return axios.post(process.env.VUE_APP_API_STORAGE_BASE_URL+'/interventions/' + payload.id + '/store_document', payload.file, optionsFormData)
            .then((response) => {
                return response
            })
    },

    updateInterventionCommentFromManagement(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/interventions/update_comment_from_management', payload, options)
            .then((response) => {
                return response
            })
    },

    updateInterventionStatus(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/status', {
            status_id: payload.statusId
        }, options).then((response) => {
            return response
        })
    },

    updateInterventionInfosPlanning(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/infos_planning', payload, options)
            .then((response) => {
                return response
            })
    },

    updateInterventionToGestion(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/return_to_gestion', payload, options)
            .then((response) => {
                return response
            })
    },

    deleteInterventionDevicesReports(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/devices/reports/delete', payload, options)
            .then((response) => {
                return response
            })
    },

    updateSignatureData(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/update_signature_data', payload, options)
            .then((response) => {
                return response
            })
    },

    updateReportData(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/update_report_data', payload, options)
            .then((response) => {
                return response
            })
    },

    getRelatedInterventions(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/interventions/' + payload.interventionId + '/get_related_interventions')
            .then((response) => {
                return response
            })
    },
}

const getters = {
    list: state => state.list,
};

const interventions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default interventions;
